var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.421 1h-3.946L16.21 4l-4.263-3H8.474L8 1.632v3.473l3.316 2.369L8 10v8.21c.053-.315.253-1.073.632-1.578.379-.506 1.842-1.58 2.526-2.053l13.579-9.475V1.474L24.42 1z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.895 8.105-4.737 3.474 4.263 2.999-5.21 3.63-4.263-2.842c-.157 0-.79.253-2.052 1.264-1.263 1.01-1.79 2.105-1.895 2.526l3.158 2.526c-.526.369-1.642 1.169-1.895 1.421-.252.253-.947.842-1.263 1.106V31l16.737-11.842V10l-2.842-1.895z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.895 22.158-4.737 3.474 3.631 2.684h3.315l.632-.632v-3.473l-2.842-2.052z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKilt);
export default __webpack_public_path__ + "static/media/KILT.4addd86a388531e9c61ef039d7355f87.svg";
export { ForwardRef as ReactComponent };